import { createSelector } from 'reselect';

const teamsState = (store) => store.apps.teamManagement.teams;

export const teamsSelector = createSelector(
  teamsState,
  (filteredState) => ({ teams: filteredState.get('results') }),
);
